import SupabaseClient from './SupabaseClient';
export * from '@supabase/gotrue-js';
export * from '@supabase/realtime-js';
/**
 * Creates a new Supabase Client.
 */

var createClient = function createClient(supabaseUrl, supabaseKey, options) {
  return new SupabaseClient(supabaseUrl, supabaseKey, options);
};

export { createClient, SupabaseClient };